import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { ErrorBoundary } from "react-error-boundary";
import { useStatsigClient } from "@statsig/react-bindings";
import { Redirect } from "react-router-dom";

import { Featured } from "./Featured";
import { ContentFeed } from "./ContentFeed";
import { SuggestedFeed } from "./SuggestedFeed";
import { HomepageWrapper } from "./styledComponents";
import { HomepageViewModel } from "./ViewModel";
import { ESupportedGames } from "../../@types";
import { GAME_TO_ICON_MAP } from "../../Components/GameSelector";
import { CampaignWidget } from "../Competitions/Components/Widget";
import { useUser } from "MVVM/Hooks/useUser";
import { ProductLandingePageState } from "MVVM/State/productLandingPage";
import { useRecoilState } from "recoil";

const Homepage = () => {
  const { contentFeeds, contentFeedsLoading } = HomepageViewModel();
  const { allstarUser } = useUser();
  const { getExperiment } = useStatsigClient();
  const [productLandingePageState, setProductLandingePageState] =
    useRecoilState(ProductLandingePageState);

  if (!allstarUser.loggedIn) {
    const showExperiment = getExperiment("product_marketing_landing_page").get(
      "landing_page_enabled",
      false,
    );

    if (showExperiment && !productLandingePageState.seen) {
      setProductLandingePageState({ ...productLandingePageState, seen: true });
      return (
        <Redirect to={{ pathname: "/start", state: { firstVisit: true } }} />
      );
    }
  }

  return (
    <HomepageWrapper>
      <HomepageContainer>
        <Featured />
        <ErrorBoundary fallback={<></>}>
          <CampaignWidget />
        </ErrorBoundary>
        <ContentFeed
          title="For You"
          data={contentFeeds?.forYou?.nodes || contentFeeds?.forYou}
          loading={contentFeedsLoading}
        />
        <ContentFeed
          title="Counter-Strike 2"
          data={contentFeeds?.cs2?.data}
          loading={contentFeedsLoading}
          icon={GAME_TO_ICON_MAP[ESupportedGames.CS2]}
        />
        <ErrorBoundary fallback={<></>}>
          <SuggestedFeed />
        </ErrorBoundary>
        <ContentFeed
          title="Popular Montages"
          data={contentFeeds?.montages?.data}
          loading={contentFeedsLoading}
          isMontageFeed={true}
        />
        <ContentFeed
          title="League of Legends"
          data={contentFeeds?.league?.data}
          loading={contentFeedsLoading}
          icon={GAME_TO_ICON_MAP[ESupportedGames.LOL]}
        />
        <ContentFeed
          title="Fortnite"
          data={contentFeeds?.fortnite?.data}
          loading={contentFeedsLoading}
          icon={GAME_TO_ICON_MAP[ESupportedGames.FORTNITE]}
        />
        <ContentFeed
          title="Dota 2"
          data={contentFeeds?.dota2?.data}
          loading={contentFeedsLoading}
          icon={GAME_TO_ICON_MAP[ESupportedGames.DOTA2]}
        />
      </HomepageContainer>
    </HomepageWrapper>
  );
};

const HomepageContainer = styled(Flex)`
  flex-direction: column;
  gap: 32px;
  max-width: 2480px;
  padding-bottom: 80px;
  width: 100vw;
`;

export default Homepage;
